import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { normalizeGenre } from '../../utils/normalizeGenre';
import { setSelectedGenre } from '../../redux/slices/podcastsSlice';
import { useGenresCache } from '../../hooks/useGenresCache';
import { Genre } from './Genre';

export const GenreList = () => {
  const dispatch = useDispatch();
  const loadGenresForCountry = useGenresCache();
  const {
    selectedGenre,
    genres,
    podcastsByGenre,
    status,
    selectedCountry,
    activePlatform,
  } = useSelector((state) => state.podcasts);

  const filteredGenres = genres.map((genre) => genre.name);

  useEffect(() => {
    if (genres.length > 0) {
      loadGenresForCountry(genres, selectedCountry);
    }
  }, [genres, selectedCountry, loadGenresForCountry, activePlatform]);

  const handleGenreClick = (genre) => {
    dispatch(setSelectedGenre(genre));
  };

  if (filteredGenres.length === 0) return null;

  return (
    <span>
      {filteredGenres.map((genre) => {
        const correctGenre = normalizeGenre(genre);
        const isPodcastsByGenreAvailable =
          genres.some((g) => g.name === correctGenre) && podcastsByGenre[correctGenre]?.length > 0;
        const isLoading = status === 'loading' && genres.some((g) => g.name === correctGenre);

        if (!isPodcastsByGenreAvailable && !isLoading) return null;

        return (
          <Genre
            key={correctGenre}
            name={correctGenre}
            isSelected={selectedGenre === correctGenre}
            isAvailable={isPodcastsByGenreAvailable}
            isLoading={isLoading}
            onClick={handleGenreClick}
          />
        );
      })}
    </span>
  );
};
